import React from "react";

export default function ComingSoon() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        textAlign: "center",
        backgroundColor: "#f9fafb",
        fontFamily: "sans-serif",
        padding: "1rem",
      }}
    >
      <h1
        style={{ fontSize: "2.5rem", marginBottom: "1rem", color: "#111827" }}
      >
        🚧 Feature Coming Soon
      </h1>
      <p style={{ fontSize: "1.25rem", color: "#4b5563", maxWidth: "500px" }}>
        We’re working hard to bring you this feature! It’s not quite ready yet,
        but it will be available soon. Stay tuned!
      </p>
    </div>
  );
}
